import { render } from "./CreateGabung.vue?vue&type=template&id=ee947412"
import script from "./CreateGabung.vue?vue&type=script&lang=js"
export * from "./CreateGabung.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__